import { AnimatePresence, m as motion } from 'framer-motion';
import { CheckCircle2, Info, X } from 'lucide-react';
import { useToasts } from '@/stores/ui';

/** Global toast stack (top-right). Feedback inmediato en cada acción. */
export function Toaster() {
  const { toasts, dismiss } = useToasts();
  return (
    <div aria-live="polite" className="fixed right-4 top-16 z-[90] flex w-80 max-w-[calc(100vw-2rem)] flex-col gap-2">
      <AnimatePresence>
        {toasts.map((t) => (
          <motion.div
            key={t.id}
            initial={{ opacity: 0, y: -8, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, x: 24 }}
            className="glass-strong flex items-center gap-2.5 rounded-xl px-3.5 py-2.5 text-sm"
          >
            {t.tone === 'success' ? (
              <CheckCircle2 className="h-4 w-4 flex-none text-success" />
            ) : (
              <Info className="h-4 w-4 flex-none text-info" />
            )}
            <span className="min-w-0 flex-1">{t.message}</span>
            <button
              type="button"
              aria-label="Dismiss"
              onClick={() => dismiss(t.id)}
              className="text-muted-foreground hover:text-foreground"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
